import React,{useEffect,useState,useMemo} from 'react';
import { v4 as uuid } from 'uuid';
import { Formik, Form } from 'formik';
import FormikControl from '../../../../../components/FormikControls/FormikControl';
import { AddEvalFace } from '../../../Interfaces/interfaces';
import DyButton from '../../../../../components/GlobalComponents/DyButton/DyButton';
import { currentStateOptions, nextStateOptions } from '../../../StataicData';
import { useAddCheckinMeeting } from '../../../Hooks/index';
import ListSelect from '../../../../../components/GlobalComponents/ListSelect/ListSelect';
import { useSelector } from 'react-redux';
import { intaddKrSchema,straddKrSchema } from '../../../StataicData';
import { useGetMeetingKeyResultValueById } from '../../../../Meeting/Hooks';
import { useGetKeyResultHistoryCheckinByKeyResultId } from '../../../Hooks/index';
import {TextField, Tooltip} from '@mui/material';
import {CircularProgress} from '@mui/material';
import { Grid,Box,Typography,Divider,Button} from '@mui/material';
import { ObjectiveSelectedFace,krSelectedFace } from '../../../Interfaces/interfaces';
import DyDataGrid from '../../../../../components/GlobalComponents/DyDataGrid2/DyDataGrid';
import DyLinearProgress from '../../../../../components/GlobalComponents/DyLinearProgress/DyLinearProgress';
import Assessor from '../../Assessor/Assessor';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import sad from '../../../../../Asset/Svgs/Emojys/sad 1.svg';
import meh from '../../../../../Asset/Svgs/Emojys/neutral 2.svg';
import smile from '../../../../../Asset/Svgs/Emojys/smil.png';
// import MoreVert from '@mui/icons-material/MoreVert';
import { ErrorMessage } from 'formik';
import DYToastMessage from "../../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import "../../../../CompanyManagment/Forms/RegisterTenant/Error.css"
import ModalLyt from '../../../../../components/Layouts/ModalLyt/ModalLyt';
import FailureReason from '../FailureReason/FailureReason';
// import IconButton from '@mui/material';
// import { useSelector } from 'react-redux';
// import {ReactComponent as Smile} from '../../../../../Asset/Svgs/Emojys/smile 1.svg';

interface CreateKRevalFace {
    cancelo : (prev:boolean) => void,
    // initialAfterAddKr:(val:boolean)=>void,
    objectiveManiInfo:ObjectiveSelectedFace|null,
    krMainInfo:krSelectedFace|null,
    pointingSystem:string|null
    kresultId:string|null,
    objectiveId:string,
    afterAddKr:() => void
}

interface progValueFace{
  assessmentRate:null|number,
  score:null|number
}

// setShowToastMessage={setShowToastMessage}
// setAddEvalAsyncData={setAddEvalAsyncData}


export const CreateKReval = ({cancelo,objectiveManiInfo,krMainInfo,objectiveId, kresultId,afterAddKr,onsucces,setAddEvalAsyncData}:any) => {
  const meetSelectedDate = useSelector((state: any) => state.meetings.meetSelectedDate);
    const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
    const teamId: any = useSelector((state: any) => state.meetings.teamInfo?.id);
    const periodId: any = useSelector((state: any) => state.meetings.priodId);
    const profileTenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
    // const[initialValuesForm,setInitialValuesForm]=useState<any>({description:''});
    const[progressFormValues,setProgressFormValues]=useState<progValueFace>({assessmentRate:0,score:0});
    const[keyResultMeetingHistoryDtos,setKeyResultMeetingHistoryDtos]=useState<any[]>([]);
    const[assessmentHistory,setAssessmentHistory]=useState<any[]>([]);
    const[showKrRequest,setShowKrRequest]=useState<Boolean>(false);
    const[need,setNeed]=useState<Boolean>(false);
    // const[hisCartActiveId,setHisCartActiveId]=useState<string>('')
    // const {data:initialNewValue,isLoading:iniValLoading}=useGetMeetingKeyResultValueById({meetingId:meetingId,krId:kresultId});
    const[formIds,setFormIds]=useState<any>({meetingId:meetingId,periodId:periodId,keyResultId:null});
    const[nextOptCurrIndex,setNextOptCurrIndex]=useState<number>(0);
    const[currOptIndex,setCurrOptIndex]=useState<number>(0);
    const[tensileScore,setTensileScore]=useState<string|null>('');
    const addKrStatusData:any=useSelector((state:any)=>state.meetings.addKrStatusData);
    // const[addKrStatus,setAddKrStatus]=useState<any>(null);
    const [showToastMessage, setShowToastMessage] = useState<any>(false);
    const [showToastMessage1, setShowToastMessage1] = useState<any>(false);
    const [showToastMessageResult, setShowToastMessageResult] = useState<any>('');
    const [helpRequested, setHelpRequested] = useState(false);

    // const addCheckinSuccess = () => {
    //     // afterAddKr()
       
    // //     let{isSuccess,metaData}=addKrStatusData;
    // // let addSt={
    // //   isSuccess:isSuccess,
    // //   message:metaData?.message
    // // }
    // //     if (isSuccess) {
    // //         // cancelo(false)
    // //         //  onsucces(true)
           
    // //     }
    // //     else{
    // //       setAddKrStatus(addSt)
    // //     }
    // // afterAddKr()
    // cancelo()
    // onsucces(true)
        
    //   }

    const {data:historyData,isLoading:historyDataLoading}:any=useGetKeyResultHistoryCheckinByKeyResultId(formIds)
    const { mutate: addCheck, isSuccess,isLoading:AddChekinLoading,data:addCheckingData } = useAddCheckinMeeting();
    
    const initialRequestShowDet=()=>{
      setShowKrRequest(true);
    }  

    const evaluationData: AddEvalFace = {
      newValue: '',
      problems: '',
      nextState: '',
      meetingId: meetingId,
      teamId: teamId,
      periodId: periodId,
      tenantId: profileTenantId,
      keyResultId: kresultId,
      objectiveId: objectiveId,
      currentState: '',
      description: '',
      closedKeyResult: false
    }
    // {...evaluationData,newValue:initialNewValue,...initialValuesForm}
   const[selectedInitialValue,setSelectedInitialValue]=useState<any>(evaluationData)
   const [pointSystemsL,setPointSystemL]=useState<string>('');

  let{name,id}:any|null=objectiveManiInfo;
  let{name:KrNAme,responsibleName,startDate,startValue,threeTenthsValue,sevenTenthsValue,oneValue}:any=krMainInfo;

  const initialSubmitForm: any = (data: any): any => {
    let totalData={...data,tensileScore:String(tensileScore)}
    // console.log(totalData)
    addCheck(totalData)
  }

  const initialCancel = (): void => {
    cancelo(false)
  }

  useEffect(() => {
  if (historyData) {
    let{assessmentRate,score,keyResultMeetingHistoryDtos,assessmentHistory}=historyData;
    let progData={assessmentRate:assessmentRate,score:score};
    setKeyResultMeetingHistoryDtos(keyResultMeetingHistoryDtos?.map((item:any)=>({id:uuid(),...item})));
    setAssessmentHistory(assessmentHistory?.map((item:any)=>({id:uuid(),...item})))
    setProgressFormValues(progData)
  }
  }, [historyData])

  useEffect(() => {
    let{id:krId,currentValue,problems,currentState,nextState,description,okR_KeyResultType,score}:any=krMainInfo;
    setPointSystemL(okR_KeyResultType);

    if (okR_KeyResultType==='مرحله ای') {
      let pureVal=score?.replace('%','');
      setTensileScore(pureVal)
    }
    let initValues={
      newValue:currentValue,
      problems:problems,
      currentState:currentState,
      nextState:nextState,
      description:description,
      tensileScore : okR_KeyResultType==='مرحله ای' ? score?.replace('%','') : ''
    }
    setFormIds((prev:any)=>({...prev,keyResultId:krId}));
    setSelectedInitialValue((prev:any)=>({...prev,...initValues}))
  }, [krMainInfo])
  
  
  
  
// keyResultMeetingHistoryDtos,setkeyResultMeetingHistoryDtos

const KRHColumns: any = useMemo(()=>
  [
    {
      field: "rowid",
      headerName: "ردیف",
      width: 35,
      sortable: false,
      align:'center',
      headerAlign:'center',
      renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
    }
    ,
    { field: 'meetingDate',
         headerName: 'تاریخ جلسه',
         sortable:false,
         headerAlign:'center',
         align:'center',
          width: 100,
          }
          ,
    
        { field: 'newValue',
        headerName: 'مقدار اعلام شده',
        align:'center',
        sortable:false,
        headerAlign:'center',
         width: 150,
         renderCell:({value}:any)=>{
          if (value!==null) {
            return <Box>
            {
             value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
             {value}
           </Tooltip>:
           <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
            }
           </Box>
          }
          else {
            return null
          }
        }         
         }
         ,
         { field: 'currentState',
       headerName: 'وضعیت ',
       align:'center',
       sortable:false,
       headerAlign:'center',
        minWidth: 120 ,
        renderCell:({value}:any)=>{
          return<Box m={3} 
          borderRadius={2} 
          width={'100%'} 
          display={'flex'} 
          justifyContent={'center'} 
          alignItems={'center'} 
          height={'75%'}   
          bgcolor={value==='در مسیر مناسب'?'#D5F7D4':value==='نیازمند توجه'?'#FFEBEF':'#F0F1F2'}  >
            <Typography fontSize={'12px'} px={8} color={value==='نیازمند توجه'?'#F95700':value==='خارج از مسیر مناسب'?'#CC0030':'black'} >
            {value}
            </Typography>
          </Box>
              }
      }
          ,
      { field: 'meetingNumber',
       align:'center',
       headerName: 'شماره جلسه',
       headerAlign:'center',
       sortable:false,
       wrap:'wrap',
        minWidth: 130,
        fontsize:'12px !important',
  }
  ,
  {
    field: 'problems',
    headerName: 'موانع',
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    minWidth: 110,
    renderCell:({value}:any)=>{
      return <Box>
       {
        value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
        {value}
      </Tooltip>:
      <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
       }
      </Box>
    }
  },
  { field: 'score',
  headerName: 'امتیاز',
  align:'center',
  sortable:false,
  headerAlign:'center',
  width: 80 ,
  renderCell:(par:any)=>{
   let score:string=par?.row?.score;
   // console.log(score);
   if ( typeof score==='string' &&  score.includes('%')) {
     let pureNum=score.slice(0,score.length-1);
     let intVal=+pureNum;
     let color='';
    let fColor=''
    switch (true) {
     case intVal>=70:
       color='#D5F7D4';
       fColor='#125610'
       break;
       case intVal<70 &&  intVal>30:
       color='#FFF8D0';
       fColor='#6B6440'
       break
     default:
       color='#FFEEE5'
       fColor='#993600'
       break;
    }
     return <Box m={3} 
     borderRadius={2} 
     width={'100%'} 
     display={'flex'} 
     justifyContent={'center'} 
     alignItems={'center'} 
     height={'65%'}   
     bgcolor={color}
     my={1}
      >

       <Typography px={8} fontSize={'0.8rem'} color={fColor} fontWeight={400} >
       {intVal}
       </Typography>
     </Box>
   }
   else{
     return<Box>
       <Typography>{score}</Typography>
     </Box>
   }
  }
 }
 ,
        // { field: 'startValue',
        // headerName: 'مقدار شروع',
        // sortable:false,
        // headerAlign:'center',
        // align:'center',
        //  width: 110 ,
        //  renderCell:({value}:any)=>{
        //   return <Box>
        //    {
        //     value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
        //     {value}
        //   </Tooltip>:
        //   <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
        //    }
        //   </Box>
        // }
        // },
        {
          field: 'startValue',
          headerName: 'مقدار شروع',
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          width: 110,
          renderCell: ({ value }: any) => {
              const formattedValue = formatValue(value); // قالب‌بندی مقدار
              return (
                  <Box>
                      {formattedValue.length > 10 ? (
                          <Tooltip sx={{ fontSize: '1.5rem !important' }} title={formattedValue}>
                              <Typography sx={{ fontSize: '12px' }}>{formattedValue}</Typography>
                          </Tooltip>
                      ) : (
                          <Typography sx={{ fontSize: '12px' }}>{formattedValue}</Typography>
                      )}
                  </Box>
              );
          }
      },
        {
          field: 'revenue',
          headerName: 'عملکرد',
          align: 'center',
          headerAlign: 'center',
          sortable: false,
          minWidth: 110,
          renderCell: ({ value }: any) => {
          if (value) {
            return <Box>
            {
              value.length > 40 ? <Tooltip sx={{ fontSize: '1.5rem !important' }} title={value}>
                {value}
              </Tooltip> :
                <Typography sx={{ fontSize: '12px' }} >{value}</Typography>
            }
          </Box>
          }
          }
        },
      
    ],[]);

    const formatValue = (value: number) => {
      return value < 0 ? `${Math.abs(value)}-` : `${value}`;
  };
  
    useEffect(() => {
    if (addCheckingData) {
      if (addCheckingData?.data.isSuccess) {
         setShowToastMessage(true)
         setShowToastMessageResult(addCheckingData?.data.metaData.message);
         setAddEvalAsyncData(addCheckingData?.data)
         onsucces(false)
      } else {
        setShowToastMessageResult(addCheckingData?.data.metaData.message);
        setShowToastMessage(true);
      }   
  }
    }, [addCheckingData])

    if (historyDataLoading) {
       return <Grid container  >
      <Box width={'100%'} py={5} textAlign={'center'} >
       <CircularProgress color='primary'   />
      </Box>
     </Grid>      
    }

  return (
    <Grid container  >
    <Grid item xs={12}  >
    <Box width={'100%'} 
    minHeight={'110px'} 
    borderRadius={2} 
    sx={{display:'flex',flexWrap:'wrap',justifyContent:'space-between',alignItems:'center'}}
    >
    <Box sx={{width:'40%',minHeight:'100px',display:'flex',flexDirection:'column',p:1,rowGap:1}}>
    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >هدف:</Typography> <Typography variant='caption'  >{name}</Typography>  </Box>
    <Divider />
    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >نتیجه کلیدی:</Typography> <Typography variant='caption'>{KrNAme}</Typography></Box>
    <Divider />
    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >مسئول:</Typography> <Typography variant='caption'>{responsibleName}</Typography>  </Box>
    <Divider />
    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >تاریخ جلسه:</Typography> <Typography variant='caption'>{meetSelectedDate}</Typography>  </Box>
 
    </Box>
    {/* <Box  sx={{width:'35%',minHeight:'100px',display:'flex',flexDirection:'column',p:1,rowGap:1}}>
   
    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >مقدار شروع:</Typography> <Typography variant='caption'  >{startValue}</Typography>  </Box>
    <Divider />

    
    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >سطح 30%:</Typography> <Typography variant='caption'  >{threeTenthsValue}</Typography>  </Box>
    <Divider />

    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  > سطح 70%:</Typography> <Typography variant='caption'  >{sevenTenthsValue}</Typography>  </Box>
    <Divider />

    <Box display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >  سطح 100%:</Typography> <Typography variant='caption'  >{oneValue}</Typography>  </Box>
  
    </Box> */}
<Box sx={{ width: '35%', minHeight: '100px', display: 'flex', flexDirection: 'column', p: 1, rowGap: 1 }}>
    <Box display={'flex'} columnGap={1} justifyContent={'start'}>
        <Typography variant='body2' fontWeight={700}>مقدار شروع:</Typography>
        <Typography variant='caption'>{formatValue(startValue)}</Typography>
    </Box>
    <Divider />

    <Box display={'flex'} columnGap={1} justifyContent={'start'}>
        <Typography variant='body2' fontWeight={700}>سطح 30%:</Typography>
        <Typography variant='caption'>{formatValue(threeTenthsValue)}</Typography>
    </Box>
    <Divider />

    <Box display={'flex'} columnGap={1} justifyContent={'start'}>
        <Typography variant='body2' fontWeight={700}>سطح 70%:</Typography>
        <Typography variant='caption'>{formatValue(sevenTenthsValue)}</Typography>
    </Box>
    <Divider />

    <Box display={'flex'} columnGap={1} justifyContent={'start'}>
        <Typography variant='body2' fontWeight={700}>سطح 100%:</Typography>
        <Typography variant='caption'>{formatValue(oneValue)}</Typography>
    </Box>
</Box>
<Box sx={{ width: '15%', minHeight: '100px', display: { xs: 'none', sm: 'block' } }}>
    <DyLinearProgress 
    value={progressFormValues?.score}
    mainLabel={'آخرین درصد تحقق نتیجه'}
     />
      <DyLinearProgress 
    value={progressFormValues?.assessmentRate}
    mainLabel={'میزان ارزیابی'}
     />
    </Box>
    </Box>
    </Grid>
    <Box
  sx={{
    width: '100%',
    minHeight: '100px',
    display: { xs: 'block', sm: 'none' }, 
  }}
>
  <DyLinearProgress 
    value={progressFormValues?.score}
    mainLabel={'آخرین درصد تحقق نتیجه'}
  />
  <DyLinearProgress 
    value={progressFormValues?.assessmentRate}
    mainLabel={'میزان ارزیابی'}
  />
</Box>

    <Grid  item xs={12} >
    {
      historyDataLoading && <Grid container  >
       <Box width={'100%'} py={5} textAlign={'center'} >
        <CircularProgress color='primary'   />
       </Box>
      </Grid>
    }
    {
       historyData && <Grid  container >
       <Grid item xs={12} mx={'auto'} sx={{bgcolor:'#F9F9F9'}}  >
       <Formik
              validationSchema={pointSystemsL==="مرحله ای"?straddKrSchema:intaddKrSchema}
               enableReinitialize
               initialValues={selectedInitialValue || evaluationData  }
               onSubmit={(data: AddEvalFace) => {
                 initialSubmitForm(data)
               }}
               validate={(data)=>{
               }}
             >
               {
                 ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }:any) => 
                   <Form>
                     {
                       true && 
                       <Grid container columnSpacing={1} sx={{bgcolor:'#F9F9F9',mx:'auto',borderRadius:3}}>    
                      <Grid item xs={12} sm={6}>
                      <div className='error'>
                      <ErrorMessage name="newValue" />
                      </div>
                         <FormikControl
                           control='textField'
                           label='مقدار جدید'
                           name='newValue'
                          value={values?.newValue ? formatValue(values.newValue) : ''}
                         />
                       </Grid>
                       
                       <Grid item xs={12}  md={6}  >
                         <FormikControl
                           control='textField'
                           type='text'
                           label='موانعی که با آن مواجه هستید؟'
                           name='problems'
                           fullWidth
                           value={values?.problems || ''}
                         />
                       </Grid>
                       {/* <Grid item xs={12} md={6}   >

              
<Box width={'99%'} mx={'auto'}   textAlign={'start'}   >
  <Typography variant='caption'  >وضعیت فعلی  نتیجه کلیدی را چگونه ارزیابی می کنید؟</Typography>
</Box>
  <Box  >
  <ButtonGroup sx={{mt:1,    '@media (max-width: 768px)': { // فقط در موبایل
      // maxWidth: '100%',  // به اندازه 100% عرض در موبایل
      justifyContent: 'space-between',
      width: '100%', 
      display: 'flex', 
      flexWrap: 'wrap', 
      maxWidth: 300, 
    }}} variant="contained" aria-label="Basic button group">
      {
        currentStateOptions && currentStateOptions.map((item:any,i:number)=>{
          let{key,value}=item
        return         <Box key={i} sx={{
          width: 'calc(50% - 8px)', // در وب دکمه‌ها به صورت 2 در 2 چیده شوند
          '@media (max-width: 768px)': { 
            width: '100%' // در موبایل دکمه‌ها به صورت full-width قرار می‌گیرند
          }
        }}>
          <Button 
          onClick={()=>{
            setCurrOptIndex(i)
            setFieldValue('currentState',value)
            i === 1 || i === 2 ? setNeed(true) : setNeed(false);
          }}
          sx={{whiteSpace:'nowrap',
          // bgcolor:value===values?.currentState?'#98b7fa':'inherit',
          bgcolor:value===values?.currentState && i === 0 ?
          '#D5F7D4' :
          value===values?.currentState && i === 1 ?
          '#FFF8D0' :
          value===values?.currentState && i === 2 ?
          '#FFEEE5':
          value===values?.currentState && i === 3 ?
          '#dfeaf7' :
          value===values?.currentState && i === 4 ?
          '#d5d9d4' :'inherit',
          minWidth:80,
          height: 30,
          '@media (max-width: 768px)': {
            minWidth: 60, // تغییر minWidth برای موبایل
            height: 25, // کاهش ارتفاع دکمه در موبایل
            fontSize: '0.75rem', // کاهش اندازه فونت برای موبایل
          }}} 
          fullWidth 
           >
            <Typography variant='caption' color={'black'} py={1} >{key}</Typography>
            </Button>
        </Box>
        })
      }
    </ButtonGroup>
  </Box>
   </Grid> */}
  <Grid item xs={12} md={6}>
  <Box width={'99%'} mx={'auto'} textAlign={'start'}>
    <Typography variant='caption'>وضعیت فعلی نتیجه کلیدی را چگونه ارزیابی می کنید؟</Typography>
  </Box>

  <Box>
    <ButtonGroup
      sx={{
        mt: 1,
        '@media (max-width: 768px)': {
          justifyContent: 'space-between',
          width: '100%',
          display: 'flex',
          flexWrap: 'wrap',
          maxWidth: 300,
        },
      }}
      variant="contained"
      aria-label="Basic button group"
    >
      {currentStateOptions &&
        currentStateOptions.map((item: any, i: number) => {
          let { key, value } = item;
          return (
            <Box
              key={i}
              sx={{
                width: 'calc(50% - 8px)',
                '@media (max-width: 768px)': {
                  width: '100%',
                },
              }}
            >
              <Button
                onClick={() => {
                  setCurrOptIndex(i);
                  setFieldValue('currentState', value);

                  // اگر کمک درخواست شده باشد، وضعیت need تغییر نکند
                  if (helpRequested) return;

                  // اگر گزینه 1 یا 2 انتخاب شد، درخواست کمک فعال شود
                  if (i === 1 || i === 2) {
                    setNeed(true);
                    setHelpRequested(true); // کمک درخواست شده
                  } else {
                    setNeed(false);
                  }
                }}
                sx={{
                  whiteSpace: 'nowrap',
                  bgcolor:
                    value === values?.currentState && i === 0
                      ? '#D5F7D4'
                      : value === values?.currentState && i === 1
                      ? '#FFF8D0'
                      : value === values?.currentState && i === 2
                      ? '#FFEEE5'
                      : value === values?.currentState && i === 3
                      ? '#dfeaf7'
                      : value === values?.currentState && i === 4
                      ? '#d5d9d4'
                      : 'inherit',
                  minWidth: 80,
                  height: 30,
                  '@media (max-width: 768px)': {
                    minWidth: 60,
                    height: 25,
                    fontSize: '0.75rem',
                  },
                }}
                fullWidth
              >
                <Typography variant="caption" color={'black'} py={1}>
                  {key}
                </Typography>
              </Button>
            </Box>
          );
        })}
    </ButtonGroup>
  </Box>
</Grid>

   <Grid item xs={12} sm={6}>
                      <Box display={'flex'}  sx={{ mt: { xs: 5, sm: 1 } }} flexDirection={'column'} justifyContent={'start'} alignItems={'start'}  >
                      <Box   textAlign={'start'} px={1} display={'flex'} alignItems={'center'}  >
                            <Typography my={'auto'} variant='caption'  >وضعیت آتی این نتیجه کلیدی را چگونه پیش بینی می کنید؟</Typography>
                          </Box>
                          {/* <Box>
                     {
                          nextStateOptions && nextStateOptions.map((item:any,i:number)=>{
                            let{key,value}=item
                            return <Tooltip key={i} arrow title={key}>
                                  <IconButton 
                                  onClick={()=>{
                                    setNextOptCurrIndex(i)
                                    setFieldValue('nextState',value)
                                    i === 1 || i === 2 ? setNeed(true) : setNeed(false);
                                  }}
                                  sx={{p:1,mx:1,
                                  bgcolor:value===values?.nextState && i === 0 ?
                                   '#D5F7D4' :
                                   value===values?.nextState && i === 1 ?
                                   '#FFF8D0' :
                                   value===values?.nextState && i === 2 ?
                                   '#facc25':'inherit',
                                  boxShadow:value===values?.nextState?3:1}} 
                                  
                                  size='large'   >
                                            {i===0?<img src={smile}  width={'25px'} />:
                                             i===1?<img src={meh}  width={'25px'}/>:
                                             i===2?<img src={sad}  width={'25px'} />:''
                                             }
                                  </IconButton>
                                </Tooltip>
                          })
                     }
                          </Box> */}
                          <Box>
  {nextStateOptions &&
    nextStateOptions.map((item: any, i: number) => {
      let { key, value } = item;
      return (
        <Tooltip key={i} arrow title={key}>
          <IconButton
            onClick={() => {
              setNextOptCurrIndex(i);
              setFieldValue('nextState', value);

              // اگر کمک درخواست شده باشد، وضعیت need تغییر نکند
              if (helpRequested) return;

              // اگر گزینه 1 یا 2 انتخاب شد، درخواست کمک فعال شود
              if (i === 1 || i === 2) {
                setNeed(true);
                setHelpRequested(true); // کمک درخواست شده
              } else {
                setNeed(false);
              }
            }}
            sx={{
              p: 1,
              mx: 1,
              bgcolor:
                value === values?.nextState && i === 0
                  ? '#D5F7D4'
                  : value === values?.nextState && i === 1
                  ? '#FFF8D0'
                  : value === values?.nextState && i === 2
                  ? '#facc25'
                  : 'inherit',
              boxShadow: value === values?.nextState ? 3 : 1,
            }}
            size="large"
          >
            {i === 0 ? (
              <img src={smile} width={'25px'} />
            ) : i === 1 ? (
              <img src={meh} width={'25px'} />
            ) : i === 2 ? (
              <img src={sad} width={'25px'} />
            ) : (
              ''
            )}
          </IconButton>
        </Tooltip>
      );
    })}
</Box>

                      </Box>
                    </Grid> 
                    {
                      need && 
                    <Grid item xs={12} md={12} >
                      <div className="flex  items-center">
                      <span className= "items-center">درخواست کمک:</span>
                      {/* <div className="h-11 w-full flex gap-x-8 items-center"> */}
                      <label className="flex gap-x-2 items-center w-1/8">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="forCertain"
                            value="forCertain"
                            id="forCertain"
                            onChange={() => setFieldValue("isPublic", false)}
                            checked={!values?.isPublic}
                          />
                          <span className="">
                          ندارم
                          </span>
                        </label>
                        <label className="flex gap-x-2 w-1/12 items-center mr-3">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="forAll"
                            value="forAll"
                            id="forAll"
                            onChange={() => setFieldValue("isPublic", true)}
                            checked={values?.isPublic}
                          />
                          <span className="">دارم</span>
                        </label>
                        
                        <div className="w-3/6">
                          {values?.isPublic && (
                            <div className=" relative cursor-pointer ">
                              <Grid item xs={12} md={12}>
                              <Button sx={{bgcolor:'#00387C'}}
                                aria-describedby={id} 
                                variant="contained" 
                                onClick={(e: React.MouseEvent<HTMLElement>) =>
                                  initialRequestShowDet()
                                }
                                >
                                ثبت درخواست
                                </Button>
                              {/* <button
                                onClick={(e: React.MouseEvent<HTMLElement>) =>
                                  initialRequestShowDet()
                                }
                                className={`btn px-4  text-xs font-thin text-white bg-[#00387c]
                                  btn-sm rounded-md m-2`}
                              >
                                ثبت درخواست
                              </button> */}
                            </Grid>
                            </div>
                          )}
                        </div>
                      </div>
                      </Grid>
                    }
                       <Grid item xs={12} md={8}  >
                         <FormikControl
                           control='textField'
                           type='text'
                           label='توضیحات'
                           name='description'
                           fullWidth
                           value={values?.description || ''}
                           placeholder={'توضیحات (اختیاری)  0/300'}
                         />
                       </Grid>

                       {
                           pointSystemsL==='مرحله ای'?
                           <Grid item xs={2}  > 
                           {/* <FormikControl
                           fullWidth
                           control='textField'
                           type='text'
                           label='امتیاز'
                           name='tensileScore'
                           value={values?.tensileScore}
                           
                         
                         /> */}
                       {/* <Box  sx={{padding:'8px'}} > */}
                       {/* <FormikControl
                           fullWidth
                           control='textField'
                          //  type='text'
                           name='tensileScore'
                         label='امتیاز' 
                         size='small'
                        //  name='tensileScore'
                         value={tensileScore || ''}
                        //  error={tensileScore===''}
                        //  type={pointSystemsL==="مرحله ای"?'text':'number'}
                          onChange={({target}:any)=>{
                            let{value}=target;
                            setTensileScore(value)
                         
                          }}
                           /> */}
                           <div className='error'>
                           <ErrorMessage name="tensileScore" />
                           </div>
                        <FormikControl
                        fullWidth
                        control='textField'
                        name='tensileScore'
                        label='امتیاز'
                        size='small'
                        value={values.tensileScore}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          const { value } = event.target;
                          setFieldValue('tensileScore', value);
                          setTensileScore(value); // به‌روزرسانی وضعیت محلی
                        }}
                      />
                    
                       </Grid>:''
                         }
                        <Grid item xs={12} md={2} >
                       <Box width={'100%'} textAlign={'center'} py={1} >
                       <Assessor 
                        setSelectedInitialValue={setSelectedInitialValue}
                        optionList={assessmentHistory} 
                        
                        />
                       </Box>
                       </Grid>

                       <Grid item xs={12}   >
                          <DyDataGrid
                          columns={KRHColumns || []}
                          data={keyResultMeetingHistoryDtos||[]}
                          setRowSelectedData={()=>{}}
                          hideFooter={true}
                          setSelectionModel={()=>{}}
                          selectionModel={''}
                          additionalToolbar={false}
                          drName={'hisTable'}
                          initialOnRowClick={()=>{}}
                          withoutOptions={true}
                          />
                      </Grid>

                       <Grid item xs={12}  >
                         <Box   columnGap={2} display={'flex'} flexDirection={'row-reverse'}  >
                           <Box >
                             <DyButton
                               caption={'ذخیره'}
                               color={'#00387C'}
                               onClick={() => { }}
                              //  disabled={!dirty || !isValid || AddChekinLoading || (pointSystemsL==="مرحله ای" && tensileScore==='' )}
                               // !isValid || !dirty 
                               variant={'contained'}
                               bgColor={'#00387C'}
                               type={'submit'}
                             />
                           </Box>
                           <Box>
                             <DyButton
                               caption={'انصراف'}
                               // color={'#00387C'}
                               // onClick={loginHandler}
                               disbled={false}
                               variant={'outlined'}
                               onClick={initialCancel}
                             />
                           </Box>
                         </Box>
                       </Grid>
                     </Grid>
                     }
                   </Form>
               }
             </Formik>
       </Grid>
        </Grid>
    }
     <Box marginTop={3}> </Box>
             {
                showKrRequest && <ModalLyt 
                showModal={showKrRequest} 
                setShowModal={setShowKrRequest}
                title={'علت وضعیت'}
                 >
                  <FailureReason 
                      keyResultId={krMainInfo?.id} 
                      meetingId={meetingId}
                      setShowToastMessage={setShowToastMessage1}
                      onClose={setShowKrRequest}
                      onSuccess={setShowKrRequest}
                      teamIdd={teamId} 
                      periodId={periodId} /> 
                </ModalLyt>
             }
    </Grid>
    {setShowToastMessage && (
          <DYToastMessage
            isSuccess={addCheckingData?.data.isSuccess}
            message={showToastMessageResult}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
         {setShowToastMessage1 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage1}
            show={showToastMessage1}
          />
        )}
    </Grid>
  )
}
